<template>
  <section v-if="popular.length || latest.length" id="recent-comparison">
    <div class="container">
      <h2 class="sr-only">Comparison</h2>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="comparison-header">
            <h3>{{ $t('general.latest_comparison') }}</h3>
            <router-link to="/compare/latest" class="comparison-link">
              {{ $t('general.show_all') }}
              <i class="far fa-chevron-circle-right"></i>
            </router-link>
          </div>

          <div class="comparison-container">
            <CardCompare
              v-for="(item, index) in latest"
              :key="index"
              :data="item" />
          </div>
        </div>

        <div v-if="!isSmallScreen" class="col-12 col-md-6">
          <div class="comparison-header">
            <h3>{{ $t('general.popular_comparison') }}</h3>
            <router-link to="/compare/popular" class="comparison-link">
              {{ $t('general.show_all') }}
              <i class="far fa-chevron-circle-right"></i>
            </router-link>
          </div>

          <div class="comparison-container">
            <CardCompare
              v-for="(item, index) in popular"
              :key="index"
              :data="item" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CardCompare from '@/components/cards/CardCompare.vue';

export default {
  name: 'HomeComparison',

  components: {
    CardCompare,
  },

  data() {
    return {
      popular: [],
      latest: [],
    };
  },

  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.popular = await this.getComparison('popular', 8);
      this.latest = await this.getComparison('latest', 3);
    },

    getComparison(sort, show) {
      const params = {
        sort_by: sort,
        show,
      };

      return this.$mainApi.get('compares/history', { params })
        .then((res) => res.data.data.result.data);
    },
  },
};
</script>

<style lang="scss" scoped>
  #recent-comparison {
    background-color: #00a8b3;
    color: #fff;

    @include media ("<=tablet") {
      padding: 1rem 0;
    }

    .comparison-header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 2rem;

      @include media ("<=tablet") {
        margin-bottom: 1rem;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      h3 {
        display: inline-block;
        margin: 0;
        font-size: 1.25rem;
        color: $white;
      }

      a {
        vertical-align: middle;

        svg {
          margin-left: 0.25rem;
        }
      }
    }

    .comparison-link {
      font-size: 0.875rem;
      color: $white;

      .arrow-circle {
        content: '';
        display: inline-block;
        height: 1em;
        width: 1em;
        margin-left: 0.25rem;
        background-color: $white;
      }
    }
  }
</style>
